import * as d3Format from 'd3-format';

import { AxelNumber, AxelType } from '../type';
import { assignWithDefined, numbersFormatTemplate } from '../util';

const DEFAULT_NUMBER_PRECISION = 0;

export default function number(localeSettings = null, opts): (data: AxelType) => string {
  let locale, formatTemplate, formatter;
  const defaults = {
    precision: DEFAULT_NUMBER_PRECISION,
    thousands: ',',
    /* if precision passed use toFixed */
    type: typeof opts.precision === 'number' ? 'f' : '',
    symbol: false,
  };

  //noinspection TypeScriptValidateTypes
  const settings: any = assignWithDefined({}, defaults, opts);

  if (localeSettings) {
    locale = d3Format.formatLocale(localeSettings);
  }

  if (settings) {
    formatTemplate = numbersFormatTemplate(settings);
  }

  formatter = locale ? locale.format(formatTemplate) : d3Format.format(formatTemplate);

  return function numberFormatter(data: AxelType) {
    if (!AxelType.isDirty(data)) {
      return formatter(data.valueOf());
    } else {
      if (data != null && data.original() !== null) {
        return data.original();
      } else {
        return '';
      }
    }
  };
}

export function rawNumber(localeSettings = null, opts): (num: number) => string {
  const formatter = number(localeSettings, opts);

  return function numberFormatter(data: number) {
    return formatter(new AxelNumber(data));
  };
}
